<template>
  <div class="page login-page-gestion">
    <div class="col col-login mx-auto">
      <div class="col-login-inner">
        <div class="text-center mb-6">
          <img src="~src/assets/images/logo.png" class="h-9" alt="">
        </div>
        <form class="card" action="" method="post" v-on:submit.prevent="login()">
          <div class="card-body p-6 pb-4">
            <div class="card-title">Se connecter</div>

            <div class="form-group">
              <label class="form-label">Nom d'utilisateur</label>
              <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" 
                v-model="data.body.username" name="username" v-validate="'required'"
                placeholder="Nom d'utilisateur" data-vv-as="Le nom d'utilisateur"
                  :class="{ 'is-invalid': errors.has('username') }">
              <div class="invalid-feedback" v-show="errors.has('username')">{{ errors.first('username') }}</div>
            </div>
            <div class="form-group">
              <label class="form-label">
                Mot de passe
              </label>
              <input type="password" class="form-control" id="exampleInputPassword1"
                v-model="data.body.password" name="password" v-validate="'required'" 
                placeholder="Mot de passe" data-vv-as="Le mot de passe"
                :class="{ 'is-invalid': errors.has('password') }">
              <div class="invalid-feedback" v-show="errors.has('password')">{{ errors.first('password') }}</div>
            </div>

            <div class="invalid-feedback" v-show="error">
              {{ error }}
            </div>

            <div class="form-footer">
              <button type="submit" class="btn btn-primary btn-block">Se connecter</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: {
          body: {
            username: '',
            password: ''
          },
          rememberMe: false
        },
        error: null
      };
    },

    created() {
      this.$store.commit("setTitle", "Se connecter");
    },

    methods: {
      login() {
        var self = this;
        self.$validator.validateAll().then((result) => {
          if(result) {
            // var redirect = self.$auth.redirect();
            self.$auth.login({
              body: self.data.body,
              rememberMe: self.data.rememberMe,
              redirect: "/",
              success() {
                console.log('success:Authorize');
              },
              error(res) {
                console.log('error:Authorize');
                self.error = "Informations invalides.";
              }
            });
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// LoginDashView.vue?db84a36c